import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Autumn/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [5, 7],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/1AddAndSubtract1s10s100sAnd1000s" */ './1AddAndSubtract1s10s100sAnd1000s'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/2AddUpToTwo4DigitNumbersNoExchange" */ './2AddUpToTwo4DigitNumbersNoExchange'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/3AddTwo4DigitNumbersOneExchange" */ './3AddTwo4DigitNumbersOneExchange'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/4AddTwo4DigitNumbersMoreThanOneExchange" */ './4AddTwo4DigitNumbersMoreThanOneExchange'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/5SubtractTwo4DigitNumbersNoExchange" */ './5SubtractTwo4DigitNumbersNoExchange'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/6SubtractTwo4DigitNumbersOneExchange" */ './6SubtractTwo4DigitNumbersOneExchange'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/7SubtractTwo4DigitNumbersMoreThanOneExchange" */ './7SubtractTwo4DigitNumbersMoreThanOneExchange'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/8EfficientSubtraction" */ './8EfficientSubtraction'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/9EstimateAnswers" */ './9EstimateAnswers'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/10CheckingStrategies" */ './10CheckingStrategies'
        )
    })
  ]
});
export default Block;
